import React, { useEffect, useState } from "react";
import Sidebar from '../../../shared/components/Sidebar';
import { Link } from "react-router-dom";
import HeaderEtd from '../../../shared/components/HeaderEtd';
//import UsersPool from "./users/UsersPool";
import AddUser from "../users/AddUser";
import Button from "@mui/material/Button";
//import "./printOut/assets/bill.css";
import Box from "@mui/material/Box";
import { getLoginInfo } from '../../../shared/utils/storage';
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import { createNotification } from '../../../shared/components/Popup';
import loadingIcon from "../../../assets/img/loadingElement.gif";
import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import Lindo from '../../../app/guards/RouteGuard';

function Administration({ UserID }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUserID, setSelectedUserID] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [userName, setUserName] = useState();
  const { handleApplicationManagement } = AppManagementReusComponent();
  const { mgambo } = Lindo()
  const administrationData = {
    OperationType: "SELECT",
    UserName: getLoginInfo().Username,
    Station: getLoginInfo().Station,
    UserID: userName,
  };

  useEffect(() => {
    handleUserPool()
  }, []);

  async function handleUserPool() {
    mgambo("Mwamba")
    setModalOpen(false)
    try {
      const result = await handleApplicationManagement(
        administrationData,
        "user_management"
      );
      setData(result?.data);
      $(document).ready(function () {
        $("#example").DataTable();
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  const openModal = (UserID) => {
    setSelectedUserID(UserID);
    setModalOpen(true);
  };
  const handleCloseModalProp = (data) => {

    setModalOpen(data)
    handleUserPool()

  }
  const styles = {
    loadingContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    loadingImage: {
      width: "70px",
      height: "70px",
    },
    td: {
      textAlign: "center",
    },
  };



  return (
    <>
      <HeaderEtd />
      <body className="">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content4">
              <div className="card-body">
                <h2 style={{ color: "#c2c2c2" }}>
                  <i>Administration Module</i>
                </h2>
              </div>

              <div className="card2">
                <div className="card-body">
                  <div className="row">
                    <div className="container">
                      <Box textAlign="center">
                        <Link to="/GlobalAdmin">
                          <Button variant="contained" color="info">
                            User Management
                          </Button>
                        </Link>
                        &nbsp;&nbsp;
                        {/* <Link to="/applicationmngt">
                          <Button variant="outlined" color="warning">
                            System Management
                          </Button>
                        </Link> */}
                      </Box>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card2">
                <div className="card-body">
                  <div className="row">
                    <div className="container">
                      <p style={{ textAlign: "right" }}>
                        <AddUser
                          isOpen={isModalOpen}
                          UserID={selectedUserID}
                          //  isInsert={true}
                          clearModalState={handleCloseModalProp}
                        />
                      </p>
                      <>
                        <div className="row">
                          <div className="container">
                            <div className="col-md-12"></div>

                            {data?.Username + loading}

                            {loading ? (

                              <div style={styles.loadingContainer}>
                                <img
                                  src={loadingIcon}
                                  alt="Loading..."
                                  style={styles.loadingImage}
                                />
                              </div>
                            ) : (
                              <table
                                id="example"
                                className="table"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  <tr>
                                    <th style={styles.td}>S/no.</th>
                                    <th>Username</th>
                                    {/* <th>Fullname</th> */}
                                    <th>Old Station</th>
                                    <th>Station</th>
                                    <th>Privilege</th>
                                    <th style={styles.td}>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {data?.length > 0 &&
                                    data.map((user, i) => (
                                      <tr key={i}>
                                        <td style={styles.td}>{i + 1}</td>
                                        <td>{user?.Username}</td>
                                        {/* <td>{user?.FullName}</td> */}
                                        <td>{user?.OldStation}</td>
                                        <td>{user?.Station}</td>
                                        <td>{user?.GroupName}</td>
                                        <td style={styles.td}>
                                          <button
                                            className=" btn-info"
                                            onClick={() =>
                                              openModal(user?.Username)
                                            }
                                          >
                                            <i className="fa fa-eye"></i> | View
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                                {/* <tfoot>
                                  <tr>
                                    <th style={styles.td}>S/no.</th>
                                    <th>Username</th>
                                    <th>Fullname</th>
                                    <th>Station</th>
                                    <th>Privilege</th>
                                    <th style={styles.td}>Action</th>
                                  </tr>
                                </tfoot> */}
                              </table>
                            )}
                          </div>
                        </div>
                        {/* {isModalOpen && (
                          <AddUser
                            isOpen={isModalOpen}
                            UserID={selectedUserID}
                          />
                        )} */}
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default Administration;
